// Documenting some of the Google API types
interface PagedResponse {
    error: string;
    nextPageToken: string;
}

interface IExecutable {
    execute(cb: (response: PagedResponse) => void): void;
}

interface GetResponse {
    result: any;
}

export interface IListAPI {
    list(): IExecutable;
    get(data?: any): Promise<GetResponse>;
}

interface ICourses extends IListAPI {
    students: IListAPI;
    courseWork: ICourseWork;
}

interface ICourseWork extends IListAPI {
    create: (data: any) => Promise<any>;
    studentSubmissions: IListAPI;
}

export interface IClassroomAPI {
    courses: ICourses;
    invitations: IListAPI;
    userProfiles: IListAPI;
}

export interface IGoogleAPI {
    // Client is loaded asynchronously, so it may not be available immediately.
    client?: {
        // Classroom is loaded manually by a call to gapi.client.load.
        classroom?: IClassroomAPI;
        load(api: string, version: string, response: any): void;
    };
}

/**
 * A check on whether an object satisfies the IGoogleAPI type at
 * runtime.
 *
 * @param x the object that may satisfy IGoogleAPI
 * @returns a boolean for whether x satisfies IGoogleAPI
 */
export function isIGoogleAPI(x: unknown): x is IGoogleAPI {
    if (!(x && typeof x === "object")) {
        return false;
    }

    const known = x as any;
    if (!(known.load && typeof known.load === "function")) {
        return false;
    }

    return true;
}
